module.exports = __webpack_public_path__ + "img/incellderm_brandfilm.d56be19e.svg";